import React, { useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './components/common/Toast';
import AppRouter from './components/routing/AppRouter';
import { confirmSplashHidden } from './capacitor/nativeInit';
import OtaLoader from './capacitor/OtaLoader';
import './App.css';

function App() {
  // Hide the native splash after first paint (no-op on web).
  useEffect(() => {
    confirmSplashHidden();
  }, []);

  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <ToastProvider>
            <div className="App min-h-screen bg-white text-gray-900">
              <AppRouter />
            </div>
            <OtaLoader />
          </ToastProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
